import { Controller } from "stimulus";

export default class extends Controller {
	static targets = ["titleCard", "shareCard", "passwordCard", "doneBtn", "backArrow", "slug", "copiedNotice"];

	connect() {

	}

	copySlug() {
		navigator.clipboard.writeText(this.slugTarget.dataset.fullUrl);
		this.copiedNoticeTarget.classList.remove("hidden");

		setTimeout(() => {
			this.copiedNoticeTarget.classList.add("hidden");
		}, 2000);
	}

	toggleCardFromArrow(e) {
		document.querySelector(".kanban-form-card.card-open").click();
	}

	toggleCard(e) {
		console.log("target", e.target);
		// if (e.target.tagName == "INPUT" || e.target.tagName == "TEXTAREA" || e.target.classList.contains("copy-slug")) return;

		if (e.target.classList.contains("kanban-form-card") == false) return;

		var selectedCard = e.target;


		var cardFormArea = selectedCard.querySelector('.card-form-area');
		var icon = selectedCard.querySelector(".card-icon")

		var elementsToHide = selectedCard.querySelectorAll(".element-to-hide")
		elementsToHide.forEach(el => {
			el.classList.toggle("hidden")
		})


		selectedCard.classList.toggle("lg:mt-0")
		selectedCard.classList.toggle("mt-20")


		icon.classList.toggle("h-20")
		icon.classList.toggle("w-20")
		icon.classList.toggle("-top-8")

		icon.classList.toggle("lg:h-36")
		icon.classList.toggle("lg:w-36")

		icon.classList.toggle("h-20")
		icon.classList.toggle("w-20")

		icon.classList.toggle("-top-12")

		this.doneBtnTarget.classList.toggle("lg:bottom-20")
		this.doneBtnTarget.classList.toggle("bottom-0")
		
		this.doneBtnTarget.classList.toggle("lg:top-20")
		this.doneBtnTarget.classList.toggle("top-20")

		// this.doneBtnTarget.classList.toggle("animate__animated")
		// this.doneBtnTarget.classList.toggle("animate__slideInUp")
		// this.doneBtnTarget.classList.toggle("animate__faster")
		selectedCard.classList.toggle("lg:w-1/3")

		selectedCard.classList.toggle("lg:mx-20")
		selectedCard.classList.toggle("lg:w-2/3")

		selectedCard.classList.toggle("w-full")
		selectedCard.classList.toggle("h-96")


		if (selectedCard.classList.contains("h-96")) {
			selectedCard.classList.add("card-open");
			this.backArrowTarget.classList.remove("hidden");
		} else {
			selectedCard.classList.remove("card-open");
			this.backArrowTarget.classList.add("hidden");
		}
				
		

		cardFormArea.classList.toggle("hidden");

		document.querySelectorAll(".kanban-form-card").forEach((card) => {
			if (card == selectedCard) return;

			card.classList.toggle("hidden");

		});
	}




	
}